<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading" class="w-full min-h-screen overflow-x-auto">

    <button *ngIf="hasData && tab !== 'distribution-center'"
        class="bg-[#415CFF] text-white shadow-md font-medium rounded-lg py-2 px-5 mr-5 text-lg flex items-center"
        (click)="downloadTemplate1()">
        <i class="fa-solid fa-download px-2" *ngIf="!isDownloading"></i>
        <i class="fa-solid fa-spinner fa-spin px-2" *ngIf="isDownloading"></i>
        {{ isDownloading ? " Downloading..." : " Download" }}
    </button>

    <div *ngIf="tab === 'distribution-center'">
        <p class="font-[500] text-[#030308] dark:text-white whitespace-nowrap">{{ regCode }} {{
            selectedCenterName }}</p>
    </div>

    <div class="flex flex-row items-center justify-between gap-4 mt-2">
        <div>
            <p class="dark:text-white whitespace-nowrap">All ({{ totalItems < 10 ? ('0' + totalItems) :
                    totalItems }})</p>
        </div>
        <div class="flex flex-row items-center justify-end gap-5 ">

            <div class="relative w-24 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectType" class="hidden" (change)="filterType()">
                    <option value="" selected disabled>Type</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pickup">
                        Pickup</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Delivery">
                        Delivery</option>

                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleTypeDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectType || 'Type' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectType" (click)="cancelType($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isTypeDropdownOpen || !selectType"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isTypeDropdownOpen"
                                [class.fa-angle-up]="isTypeDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isTypeDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of typeDropdownOptions" (click)="selectTypeOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="relative w-52 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectTimeSlot" class="hidden" (change)="filterTimeSlot()">
                    <option value="" selected disabled>TimeSlot</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pickup">
                        Pickup</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Delivery">
                        Delivery</option>

                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleTimeSlotDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectTimeSlot || 'TimeSlot' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectTimeSlot" (click)="cancelTimeSlot($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isTimeSlotDropdownOpen || !selectTimeSlot"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isTimeSlotDropdownOpen"
                                [class.fa-angle-up]="isTimeSlotDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isTimeSlotDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of timeSlotDropdownOptions" (click)="selectTimeSlotOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>


            <div class="relative w-28 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectRow" class="hidden" (change)="filterRow()">
                    <option value="" selected disabled>Type</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pickup">
                        Pickup</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Delivery">
                        Delivery</option>

                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleRowDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectRow || 'Row' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectRow" (click)="cancelRow($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isRowDropdownOpen || !selectRow"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isRowDropdownOpen" [class.fa-angle-up]="isRowDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isRowDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of rowDropdownOptions" (click)="selectRowOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">Row {{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>


            <div class="relative w-28 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectStatus" class="hidden" (change)="filterStatus()">
                    <option value="" selected disabled>Status</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Pending">
                        Pending</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Completed">
                        Completed</option>
                    <option class="dark:bg-[#272F45] text-textLight dark:text-textDark hover:bg-gray-300"
                        value="Opened">
                        Opened</option>
                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleStatusDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectStatus || 'Status' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectStatus" (click)="cancelStatus($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isStatusDropdownOpen"
                                [class.fa-angle-up]="isStatusDropdownOpen"></i>
                        </div>
                    </div>
                </div>



                <!-- Custom dropdown options -->
                <div *ngIf="isStatusDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of statusDropdownOptions" (click)="selectStatusOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-32">
                <app-custom-datepicker [placeholder]="'Date'" [selectedDate]="selectedDate"
                    (dateChange)="onDateChange($event)"></app-custom-datepicker>
            </div>



            <div
                class="flex items-center rounded-full mr-5 px-4 py-2 w-96 sm:w-64 md:w-64 bg-[#F1F1F1] dark:bg-[#292929]">

                <input type="text" placeholder="Search by Order ID.." [(ngModel)]="searchText"
                    (keydown)="onKeydown($event)" (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                    class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button *ngIf="searchText" type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

        </div>
    </div>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen mt-6">
        <p class="text-[#494949] my-6 dark:text-white">--No Data Available--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>


    <div *ngIf="hasData"
        class="overflow-hidden min-w-max mt-5 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full divide-y-2 overflow-hidden">
            <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                <tr>
                    <th class="px-6 py-3 text-left font-medium text-[#FFFFFFF] dark:text-white">No</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Order ID</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Type</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Assigned Row</th>
                    <th class="px-6 py-3 text-left font-medium text-[#4B5563] dark:text-white">Delivery Time Slot</th>
                    <th class="px-6 py-3 text-center font-medium text-[#4B5563] dark:text-white">Status</th>

                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                <tr *ngFor="let item of ordersArr let i = index">
                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">
                        {{ (i + 1) < 10 ? ('0' + (i + 1)) : (i + 1) }} </td>
                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">{{item.invNo}}</td>
                    <td class="px-6 py-4 font-medium text-gray-900 dark:text-[#C5C5C5]">{{item.delivaryMethod}}</td>
                    <td class="px-6 py-4 font-medium  text-left  text-gray-900 dark:text-[#C5C5C5]">Row
                        {{item.rowIndex}}</td>


                    <td class="px-6 py-4 text-gray-900 text-left dark:text-[#C5C5C5] cursor-default">

                        <div class="font-medium">
                            <span [style.color]="getDateColor(item)">
                                {{ getDisplayDate(item.sheduleDate) }} {{ removeWithin(item.sheduleTime) }}
                            </span>
                        </div>
                    </td>
                    <td class="px-6 py-4 text-gray-900 dark:text-[#C5C5C5] cursor-default">

                        <div class="flex font-medium items-center justify-center h-full">
                            <span *ngIf="item.combinedStatus ==='Completed'"
                                class="bg-[#C8E0FF] text-center text-[#415CFF] px-3 py-1 rounded-lg min-w-32">
                                Completed
                            </span>

                            <span *ngIf="item.combinedStatus ==='Pending'"
                                class="bg-[#FFD4D4] text-center text-[#FF0000] px-3 py-1 rounded-lg min-w-32">
                                Pending
                            </span>

                            <span *ngIf="item.combinedStatus ==='Opened'"
                                class="bg-[#FFFDC5] text-center text-[#A8A100] px-3 py-1 rounded-lg min-w-32">
                                Opened
                            </span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>